/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./themeImage.vue?vue&type=template&id=13b0be08&scoped=true"
import script from "./themeImage.vue?vue&type=script&lang=js"
export * from "./themeImage.vue?vue&type=script&lang=js"
import style0 from "./themeImage.vue?vue&type=style&index=0&id=13b0be08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b0be08",
  null
  
)

export default component.exports